/**
 * Appends a permission grant entry to the given form data.
 * @param {FormData} data Form data to append to.
 * @param {number} index Attribute index for this entry.
 */
export function appendPermissionGrant(data, index, {permissionId, subjectUserId}) {
  data.append(`superior_user_permissions_attributes[${index}][permission_id]`, permissionId);
  if (subjectUserId !== undefined) {
    data.append(`superior_user_permissions_attributes[${index}][subject_user_id]`, subjectUserId);
  }
}

/**
 * Appends a permission destroy entry to the given form data.
 * @param {FormData} data Form data to append to.
 * @param {number} index Attribute index for this entry.
 */
export function appendPermissionDestroy(data, index, {id}) {
  data.append(`superior_user_permissions_attributes[${index}][id]`, id);
  data.append(`superior_user_permissions_attributes[${index}][_destroy]`, true);
}
